import { User } from "@/types/user"
import axios from "./userInstance"

export default async (page = 1, size = 100) => {
  try {
    const response = await axios(`/users/`)
    return response.data
  } catch (error) {
    return [] as User[]
  }
}
